import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_2227_time_shift_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Time Shift Add",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        Label: "",
                        BindValue: "cont_Action",
                        style: {
                            direction: FlexDirection.ROW,
                            padding: 0,
                            margin: 0,
                            marginBottom: 16,
                        },
                        childComponents: [],
                    },
                    {
                        componentType: LayoutTypes.FORM,
                        Name: "time_shift_add",
                        TableName: "time_shift",
                        DisplayName: "Time Shift Details",
                        columnNumber: "m1 t1 w3",
                        style: {
                            padding: 10,
                            backgroundColor: "#ffffff",
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "shift_code",
                                label: "Shift Code",
                                placeholder: "Auto-generated",
                                required: false,
                                inputType: InputType.TEXT,
                                maxLength: 100,
                                isReadOnly: true,
                                disabled: true,
                                Json_Attribute: "shift_code",
                                IsVerticalView: true,
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "shift_name",
                                label: "Shift Name",
                                placeholder: "e.g. Morning Shift",
                                required: true,
                                inputType: InputType.TEXT,
                                maxLength: 255,
                                Json_Attribute: "shift_name",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Shift Name is required",
                                    },
                                    {
                                        rule: ValidationRule.MAX_LENGTH,
                                        value: 255,
                                        message: "Shift Name must be at most 255 characters",
                                    },
                                ],
                            },
                            {
                                componentType: ComponentType.SELECT_DROPDOWN,
                                name: "shift_type",
                                label: "Shift Type",
                                placeholder: "Select Shift Type",
                                required: true,
                                options: [
                                    {
                                        label: "Regular Shift",
                                        value: "Regular Shift"
                                    }
                                ],
                                Json_Attribute: "shift_type",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Shift Type is required"
                                    }
                                ]
                            },
                            {
                                componentType: ComponentType.RADIO_FIELD,
                                name: "category",
                                label: "Category",
                                direction: FlexDirection.ROW,
                                defaultValue: "Flexible",
                                options: [
                                    {
                                        label: "Flexible (Total hours based)",
                                        value: "Flexible"
                                    },
                                    {
                                        label: "Fixed",
                                        value: "Fixed"
                                    }
                                ],
                                Json_Attribute: "category",
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "start_time",
                                label: "Start Time",
                                placeholder: "09:00",
                                required: true,
                                inputType: "time" as InputType,
                                Json_Attribute: "start_time",
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Start Time is required"
                                    },
                                    {
                                        rule: ValidationRule.PATTERN,
                                        value: "^([0-1][0-9]|2[0-3]):[0-5][0-9]$",
                                        message: "End Time must be in 24-hour format (HH:MM)"
                                    }
                                ]
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "end_time",
                                label: "End Time",
                                placeholder: "17:00",
                                required: true,
                                inputType: "time" as InputType,
                                Json_Attribute: "end_time",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "End Time is required"
                                    },
                                    {
                                        rule: ValidationRule.PATTERN,
                                        value: "^([0-1][0-9]|2[0-3]):[0-5][0-9]$",
                                        message: "End Time must be in 24-hour format (HH:MM)"
                                    }
                                ]
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "break_start_time",
                                label: "Break Start Time",
                                placeholder: "13:00",
                                required: false,
                                inputType: "time" as InputType,
                                Json_Attribute: "break_start_time",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.PATTERN,
                                        value: "^([0-1][0-9]|2[0-3]):[0-5][0-9]$",
                                        message: "End Time must be in 24-hour format (HH:MM)"
                                    }
                                ]
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "break_end_time",
                                label: "Break End Time",
                                placeholder: "14:00",
                                required: false,
                                inputType: "time" as InputType,
                                Json_Attribute: "break_end_time",
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.PATTERN,
                                        value: "^([0-1][0-9]|2[0-3]):[0-5][0-9]$",
                                        message: "End Time must be in 24-hour format (HH:MM)"
                                    }
                                ]
                            },
                            {
                                componentType: ComponentType.TEXT_FIELD,
                                name: "total_work_duration",
                                label: "Total Work Duration (Hours)",
                                placeholder: "Auto-calculated",
                                required: false,
                                inputType: InputType.NUMBER,
                                isReadOnly: true,
                                disabled: true,
                                Json_Attribute: "total_work_duration",
                                IsVerticalView: true,
                                Default_Value: "0",
                                // Overnight-safe duration:
                                // shift = (end < start ? end+24 : end) - start
                                // break = only if both break times are set (non-zero), also overnight-safe
                                ExpressionV2:
                                    "((([end_time] < [start_time]) ? ([end_time] + 24) : [end_time]) - [start_time]) - ((([break_start_time] > 0) && ([break_end_time] > 0)) ? ((([break_end_time] < [break_start_time]) ? ([break_end_time] + 24) : [break_end_time]) - [break_start_time]) : 0)",
                            },
                            {
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                name: "transaction_branch_id",
                                label: "Applicable Branch/Location",
                                placeholder: "Select Branch (Optional)",
                                required: false,
                                lookupName: "branches",
                                Json_Attribute: "transaction_branch_id",
                                IsVerticalView: true,
                            },
                            {
                                componentType: ComponentType.TEXT_AREA,
                                name: "description",
                                label: "Description",
                                placeholder: "Optional description about this shift",
                                required: false,
                                rows: 3,
                                Json_Attribute: "description",
                                maxLength: 500,
                                validation: [
                                    { rule: ValidationRule.MAX_LENGTH, value: 500, message: "Description must be at most 500 characters" },
                                ],
                            },
                            {
                                componentType: LayoutTypes.GROUP,
                                style: {
                                    direction: FlexDirection.ROW,
                                    padding: 16,
                                    gap: 12,
                                },
                                childComponents: [
                                    {
                                        componentType: ComponentType.BUTTON,
                                        name: "Submit",
                                        Label: "Submit",
                                        BindValue: "btn_submit",
                                        onPressAction: "save",
                                        ActionType: "Add",
                                        ScreenId: "2227",
                                        style: {
                                            backgroundColor: "var(--primary-green)",
                                            textColor: "#FFFFFF",
                                            padding: 12,
                                            borderRadius: 6,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
